import { NestedAction, NestedContentNavigator } from "@/shared/components/ui/NestedContentNavigator";
import { DrawerAndPopover } from "../common/DrawerAndPopover";

export type MenuItem = NestedAction;

interface MenuProps {
  items?: MenuItem[];
}

export function Menu({ items = [] }: MenuProps) {
  return (
    <DrawerAndPopover id="menu">
      <NestedContentNavigator classNames={{ content: "max-h-80" }} actions={items} />
    </DrawerAndPopover>
  );
}
